module.exports = __webpack_public_path__ + "static/img/likeIcon.8e5598c1.svg";